export default __webpack_public_path__ + "static/media/wavy.63b312b6.png";